module.exports = "<div class=\"side-menu\" v-if=\"isDisplayed\">\n    <slot />\n</div>\n"